// extracted by mini-css-extract-plugin
export default {"footer":"YK2Ar7KeaJgvY3BzcE5WHQ==","footerLinks":"G8xOB514FORvrN3z-LNytA==","twitterURL":"KwIU-Ka2W2uAGw+hfV3qGw=="};